import React from 'react';
import { Typography, Card, CardContent, Box } from '@mui/material';

const About = () => (
    <Card sx={{ mb: 3, boxShadow: 2, borderRadius: 2 }}>
        <CardContent>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
                About Me
            </Typography>
            <Box>
                <Typography variant="body1" display="block">
                    As a seasoned Software Engineer with over 7 years of experience, I am dedicated to transforming complex ideas into efficient, user-centered solutions. My expertise spans across the .NET ecosystem, including both desktop applications with WPF and web frameworks such as ASP.NET and Blazor, supported by my strong foundations in C#, SQL, and front-end technologies like JavaScript and React.
                </Typography>
                <Typography variant="body1" display="block">
                    I am passionate about clean architecture, scalable APIs, and optimizing database interactions to ensure robust performance and seamless user experiences. Every project is a new opportunity to craft technology that bridges gaps and enables people to achieve more, with special focus on trustworthiness and efficiency—values that guide my approach as much as my technical skillset.
                </Typography>
                <Typography variant="body1" display="block">
                    From implementing CI/CD pipelines in Azure DevOps to managing cloud resources in Azure and collaborating through Git, I believe in leveraging the right tools and practices to drive results. I approach each project not only with skill, but with a commitment to quality, reliability, and continuous learning, always aiming to refine and elevate the impact of my work.
                </Typography>
            </Box>
        </CardContent>
    </Card>
);

export default About;